export const SET_SUPPLIER_EDIT_CREATERECEIPT =
  "SET_SUPPLIER_EDIT_CREATERECEIPT";
export const SET_AGENTS_EDIT_CREATERECEIPT = "SET_AGENTS_EDIT_CREATERECEIPT";
export const SET_CODES_EDIT_CREATERECEIPT = "SET_CODES_EDIT_CREATERECEIPT";
export const SET_DEFAULT_TAXATION_EDIT_CREATERECEIPTS =
  "SET_DEFAULT_TAXATION_EDIT_CREATERECEIPTS";
export const RETURN_DEFAULT_TAXATION_EDIT_CREATERECEIPTS =
  "RETURN_DEFAULT_TAXATION_EDIT_CREATERECEIPTS";
